import { render, staticRenderFns } from "./MultipleForm.vue?vue&type=template&id=37aeb89c&scoped=true&"
import script from "./MultipleForm.vue?vue&type=script&lang=js&"
export * from "./MultipleForm.vue?vue&type=script&lang=js&"
import style0 from "./MultipleForm.vue?vue&type=style&index=0&id=37aeb89c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aeb89c",
  null
  
)

export default component.exports